import { render } from "./ziHome.vue?vue&type=template&id=ab988f48&scoped=true"
import script from "./ziHome.vue?vue&type=script&lang=js"
export * from "./ziHome.vue?vue&type=script&lang=js"

import "./ziHome.vue?vue&type=style&index=0&id=ab988f48&scoped=true&lang=css"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab988f48"]])

export default __exports__